import React from 'react';
import { useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { configData } from "../config";
import './classes/SubscriptionUpdate.css';
import Loading from './Loading';
import './classes/SubscriptionEdit.css';

const SubscriptionEdit = () => {

  const {subscription_id} = useParams();
  const {id} = useParams();
  const[userOrderDetails,setUserOrderDetails] = useState({});
  const[error,setError] = useState({});
  const[success,setSuccess] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [buttontext, setButtonText] = useState("Change");
  const [isLoading, setIsLoading] = useState(true);
  
  const uid = localStorage.getItem('uid');
  const app_url = configData.APP_URL;
  const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
  var loggedin_domain = drupal_domain_url;

  const [formData, setFormData] = useState({
      status: '',
      uid:uid,
      note: '',
      recur_id:id,
      subscription_id:subscription_id
    })
    const handleChange = event => {
      const { name, value} = event.target;
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
      }));
    }
    const validateForm = (data) => {
    const errors = [];
    console.log(data);
    if (!data.status.trim()) {
      
      errors.push("Please Select Status.");
    }
     if (!data.note.trim()) {
      
      errors.push("Please enter Notes.");
    }
    return errors;
  }
  const handleSubmit = async event => {
    event.preventDefault();
    const newErrors = validateForm(formData);
    setError(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setDisabled(true);
      setButtonText("Saving please wait...");
      const postData = formData; 
      const response = await fetch(app_url+'authnetsubscription/changeorderstatus', {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSuccess(responsedata.data.result);
      setError('');
      setDisabled(false);
      window.location.href = "/user/"+userOrderDetails.drupal_uid+"/my_orders";
      
      
    } else {
      setError(responsedata.data.result);
      setDisabled(false);
       setButtonText("Change");
    }
    }
  }
    useEffect(() => {
     
      retrieveSubscriptionOrderDetails();
      setTimeout(() => {
        setIsLoading(false);
      }, 800);
    },[]);
    async function retrieveSubscriptionOrderDetails() {
      if(subscription_id) {
      const response = await fetch(
        app_url+'authnetsubscription/getorderstatusdetails?subscription_id='+subscription_id+'&id='+id,
        {
          method: "GET",
    
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      const responsedata = await response.json();
      if(responsedata.data.msg === "Success") {
      
        setUserOrderDetails(responsedata.data.result);
      
      } else {
        setError(responsedata.data.result);
      }
      
     
    }
    }

  return (
    <div className="subs-update-container">
      <div className="cchange-content">
        {error.length > 0 && (
          <div className="set-message-error">
           {error.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
       
         {success.length > 0 && (
          <>
           {success.map((item, index) => {
             return <>
            <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {item}
          </div></>
          
        })}  
          </>
        )}
        <div className="subs-update-header-container">
        <h2>Update Subscription Status</h2>
        <a href={"/user/"+userOrderDetails.drupal_uid+"/my_orders"}>← Back</a>
      </div>
        <table className="cchange-table cchange-table-bordered cchange-table-striped">
          <thead>
            <tr>
              <th width="10%">Order #</th>
              <th width="20%">Product</th>
              <th width="12%">Due date</th>
              <th width="10%">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{userOrderDetails.order_id}</td>
              <td>{userOrderDetails.product_title}</td>
              <td>{userOrderDetails.due_date}</td>
              <td>{userOrderDetails.sub_status}</td>
            </tr>
          </tbody>
        </table>

        <h2>Change Order Status</h2>
        <form className="credit-card-form">
        <div className="cchange-form-group">
            <label>Status *</label>
            <div className="cchange-expiration-date">
              <select name='status' className='cc-edit-order-status' onChange={handleChange}>
                <option>-Selected</option>
                <option>Completed</option>
               
              </select>
            </div>
          </div>

          <div className="cchange-form-group">
            <label>Note *</label>
            <div className="cchange-expiration-date">
                <textarea name="note" onChange={handleChange} />
            </div>
          </div>
         
          <div className="cchange-form-actions">
            <button className='cchange-submit' type="submit" disabled={disabled} onClick={handleSubmit}>{buttontext}</button>
             <a href={"/user/"+userOrderDetails.drupal_uid+"/my_orders"}><button className='cchange-maybelater' type="button">Maybe Later!</button></a>
          </div>
        </form>
      </div>
      <div className="cchange-quick-links">
        <h3>Quick Links</h3>
        <ul>
        <li className='header-hello-text'><a className="quick_link_anchor">Manage My Profile</a></li>
            <li>
              <a href="/smww_pay">
              <input type="button" className='quick-links-reg-button' value="Register for a Course"/>
              </a>
            </li>
        </ul>
      </div>
    </div>
  );
};

export default SubscriptionEdit;
